import { ScoutingStartup } from '../api/scoutingService'

const asOptionalString = (value: unknown): string | undefined => {
  if (value == null) return undefined
  if (typeof value === 'string') return value
  return String(value)
}

export function getScoutingListRows(response: { rows?: unknown[]; Rows?: unknown[] } | null | undefined): any[] {
  if (response == null) return []
  const rows = response.rows ?? response.Rows
  return Array.isArray(rows) ? rows : []
}

const getStartupRowId = (startup: Record<string, unknown>): string =>
  String(
    startup.startupCompanyId ??
    startup.StartupCompanyId ??
    startup.id ??
    startup.Id ??
    ''
  )

export function getConnectionFunnelStartups(response: unknown): any[] {
  if (response == null) return []

  const record = response as Record<string, unknown>
  const stages = record.stages ?? record.Stages
  if (!Array.isArray(stages)) return []

  const collectStageStartups = (stage: unknown): unknown[] => {
    const item = stage as Record<string, unknown>
    const startups = item.startups ?? item.Startups
    return Array.isArray(startups) ? startups : []
  }

  const interestStage = stages.find((stage) => {
    const item = stage as Record<string, unknown>
    return item.isSyntheticInterest === true || item.IsSyntheticInterest === true
  })

  const sourceStages = interestStage ? [interestStage] : stages
  const seen = new Set<string>()
  const result: unknown[] = []

  sourceStages.forEach((stage) => {
    collectStageStartups(stage).forEach((startup) => {
      const row = startup as Record<string, unknown>
      const id = getStartupRowId(row)
      if (!id || seen.has(id)) return

      seen.add(id)
      result.push(startup)
    })
  })

  return result
}

export function normalizeScoutingStartupRow(startup: any): ScoutingStartup {
  const logo =
    startup.logo ??
    startup.logoUrl ??
    startup.LogoUrl ??
    startup.profileImage

  return {
    id: String(startup.id ?? startup.startupId ?? startup.startupCompanyId ?? startup.StartupCompanyId ?? ''),
    name:
      startup.name ||
      startup.Name ||
      startup.companyName ||
      startup.startupInfo?.name ||
      '',
    logo: typeof logo === 'string' ? logo : undefined,
    description:
      startup.description ||
      startup.summary ||
      startup.Summary ||
      startup.pitch ||
      startup.pitchFull ||
      startup.startupInfo?.pitch ||
      '',
    businessModel: asOptionalString(
      startup.businessModel ?? startup.BusinessModel ?? startup.startupInfo?.businessModel
    ),
    target: asOptionalString(
      startup.target ?? startup.targetAudience ?? startup.TargetAudience ?? startup.startupInfo?.target
    ),
    numberEmployees: asOptionalString(
      startup.numberEmployees ??
      startup.employeeCount ??
      startup.EmployeeCount ??
      startup.startupInfo?.numberEmployees
    ),
    addressState: startup.addressState || startup.state || startup.State || startup.address?.state,
    selected: startup.selected || false,
    category:
      startup.category ||
      startup.segment ||
      startup.Segment ||
      startup.activity ||
      startup.startupInfo?.activity,
    contactName: startup.contactName,
    contactPhone: startup.contactMobile || startup.contactPhone,
    contactEmail: startup.emailContact,
    cnpj: startup.cnpj,
    website: startup.website,
    technologies: startup.technologies || startup.startupInfo?.technologies,
    developmentStage: startup.developmentStage || startup.startupInfo?.developmentStage,
    annualTurnover: startup.annualTurnover ?? startup.startupInfo?.annualTurnover,
    investmentCaptured: startup.amount ?? startup.startupInfo?.amount,
    addressLineOne: startup.addressLineOne,
    addressNumber: startup.addressNumber,
    addressCity: startup.addressCity,
    opportunityScoutingStageId: startup.opportunityScoutingStageId
  }
}
